import React, { Fragment } from 'react'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid';
import SolicitudesEnRevisionOCNacionalComponent from './SolicitudesEnRevisionOCNacionalComponent';
import SeguimientoOCNacionalComponent from './SeguimientoOCNacionalComponent';

function TabsOCNacionalDGComponent(props) {

    const dispatch = useDispatch()
    //const solicitudes = useSelector(store => store.EstatusSolicitudesUIF01.estatusSolicitudesAC)

    const [tabSolicitudes, setTabSolicitudes] = React.useState('En revisión por OC');

    const handleChangeSolicitudesTab = (event, newValue) => {
        setTabSolicitudes(newValue);
    };

    return (
        <Fragment>
            <Box sx={{ width: '80%', typography: 'body1', margin: 'auto', fontFamily: 'Montserrat' }} className="mt-4">
            <h3 className='text-center tm'><b>MODULO ORGANISMO DE CERTIFICACIÓN NACIONAL</b></h3><br />
                <TabContext value={tabSolicitudes}>
                    <Box sx={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        textAlign: 'center', backgroundColor: '#fcfcfc',
                        boxShadow: '0 0px 16px 0px rgba(0, 0, 0, 0.3)', height: '60px', borderRadius: '8px'
                    }}>
                        <TabList onChange={handleChangeSolicitudesTab} aria-label="visible arrows tabs example" variant="scrollable" scrollButtons="auto" className='text-center'
                            TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                            sx={{
                                "& button": { color: '#7D9A47', fontFamily: 'Montserrat', fontWeight: 'bold' },
                                "& button:hover": { color: '#7D9A47', transform: 'scale(1.1)' },
                                "& button.Mui-selected": { backgroundColor: '#7D9A47', color: 'white', borderTopLeftRadius: 9, borderTopRightRadius: 9, borderBottomLeftRadius: 9, borderBottomRightRadius: 9 }
                            }}>
                            <Tab label="En revisión por OC" value="En revisión por OC" />
                            <Tab label="Seguimiento" value="Seguimiento" />
                        </TabList>
                    </Box>
                    <TabPanel value="En revisión por OC" style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <SolicitudesEnRevisionOCNacionalComponent />
                    </TabPanel>
                    <TabPanel value="Seguimiento" style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <SeguimientoOCNacionalComponent />
                    </TabPanel>
                </TabContext>
            </Box>
        </Fragment >
    )
}

export default withRouter(TabsOCNacionalDGComponent)